import { Avatar, Button, Flex, Layout, Menu, Tooltip, Typography } from "antd";
import { siderMenus } from "../utils/siderMenus";
import { useLocation, useNavigate } from "react-router";
import { useCallback, useState } from "react";
import type { MenuClickEventHandler } from "@rc-component/menu/lib/interface";
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, RobotFilled, SyncOutlined } from "@ant-design/icons";
import { useLogto } from "@logto/react";
import useAutoLogin from "../hooks/useAutoLogin";
import { useUserClaims } from "../hooks/useUserClaims";

export const LayoutSider = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { autoSignIn } = useAutoLogin();
  const { signOut } = useLogto();
  const [claims] = useUserClaims();
  const handleItemClick = useCallback<MenuClickEventHandler>((e) => {
    console.debug('click', e);
    navigate(e.key);
  }, []);
  const [collapsed, setCollapsed] = useState(false);
  return (
    <Layout.Sider
      className="app-sider"
      width={248}
      collapsible
      trigger={null}
      breakpoint="md"
      collapsedWidth={72}
      collapsed={collapsed}
      onCollapse={(v => setCollapsed(v))}
    >
      <Flex vertical style={{ height: '100%', position: 'relative' }}>
        <Flex className="brand" align="center" gap={12}>
          <Avatar shape="square" size={40} icon={<RobotFilled />} />
          {!collapsed && <Flex vertical className="brand-copy">
            <Typography.Text strong className="brand-name">MY BANDAI</Typography.Text>
            <Typography.Text type="secondary" className="brand-caption">AUTOMATION HUB</Typography.Text>
          </Flex>}
          <Button
            className="collapse-button"
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(value => !value)}
            aria-label={collapsed ? '展开菜单' : '收起菜单'}
          />
        </Flex>
        <Flex flex={1}>
          <Menu
            className="app-menu"
            selectedKeys={[location.pathname]}
            items={siderMenus.map(e => ({
              key: e.path,
              label: e.title,
              icon: e.icon,
              type: 'item',
            }))}
            onClick={handleItemClick}
          />
        </Flex>
        <Flex vertical gap={12} className="user-panel">
          {!collapsed && <Typography.Text ellipsis type="secondary">{claims?.sub}</Typography.Text>}
          <Flex vertical={collapsed} gap={8}>
            <Tooltip title="刷新权限" placement="right"><Button className="user-action" block onClick={() => autoSignIn()} icon={<SyncOutlined />}>{!collapsed && '同步'}</Button></Tooltip>
            <Tooltip title="退出登录" placement="right"><Button className="user-action" block danger icon={<LogoutOutlined />} onClick={() => signOut(`${window.origin}/`)}>{!collapsed && '退出'}</Button></Tooltip>
          </Flex>
        </Flex>
      </Flex>
    </Layout.Sider>
  );
}
